import { useCallback, useState } from "react";

export type textContentRef = ((node: Node) => void) & { current?: string };
export function useTextContent(initial: string) {
  const [textContent, setTextContent] = useState(initial);

  const ref: textContentRef = useCallback((node: Node) => {
    if (node && node.textContent !== null) {
      setTextContent(node.textContent);
    }
  }, []);

  ref.current = textContent;
  return ref;
}
